import { ReactNode } from "react"

type BaseButtonColorway = "primary" | "secondary" | "warning"
type BaseButtonVariant = "solid" | "ghost" | "outline"
type BaseButtonSize = "default" | "small"

type BaseButtonProps = {
    label: string
    func: (e?: any) => void
    classProps?: string
    disabled?: boolean
    type?: "button" | "submit" | "reset"
    icon?: ReactNode
    hideLabelOnMobile?: "sm" | "md" | "lg" | "xl" | "2xl" | "always"
    colorway?: BaseButtonColorway
    variant?: BaseButtonVariant
    size?: BaseButtonSize
}

const colorwayClasses: Record<BaseButtonVariant, Record<BaseButtonColorway, string>> = {
    solid: {
        primary: "bg-white shadow-lg border-none hover:bg-gray-100",
        secondary: "bg-primary text-white shadow-lg border-none hover:brightness-110 [&_svg]:text-white",
        warning: "bg-red-500 text-white shadow-lg border-none hover:brightness-95 [&_svg]:text-white",
    },
    ghost: {
        primary: "btn-ghost bg-transparent shadow-none text-primary hover:bg-primary/10",
        secondary: "btn-ghost bg-transparent shadow-none text-primary hover:bg-primary/10",
        warning: "btn-ghost bg-transparent shadow-none text-red-600 hover:bg-red-600/10 [&_svg]:text-red-600",
    },
    outline: {
        primary: "btn-outline bg-transparent shadow-none border-primary text-primary hover:bg-primary/10 hover:border-primary hover:text-primary [&_svg]:text-primary",
        secondary: "btn-outline bg-transparent shadow-none border-primary text-primary hover:bg-primary/10 hover:border-primary hover:text-primary [&_svg]:text-primary",
        warning: "btn-outline bg-transparent shadow-none border-red-500 text-red-600 hover:bg-red-600/10 hover:border-red-500 hover:text-red-600 [&_svg]:text-red-600",
    },
}

const sizeClasses: Record<BaseButtonSize, string> = {
    default: "",
    small: "min-h-8 h-8 px-3 text-sm gap-1 [&_svg]:w-4 [&_svg]:h-4 [&_p]:text-sm",
}

export default function BaseButton(props: BaseButtonProps) {
    const colorway = props.colorway ?? "primary"
    const variant = props.variant ?? "solid"
    const size = props.size ?? "default"

    return (
        <button
            type={props.type}
            disabled={props.disabled}
            className={`btn ${colorwayClasses[variant][colorway]} ${sizeClasses[size]} ${props.classProps}`}
            onClick={props.func}>
            {props.icon}
            <p className={props.hideLabelOnMobile === "always" ? "hidden" : props.hideLabelOnMobile && `hidden ${props.hideLabelOnMobile}:block ${props.label === "" ? "!hidden" : ""}`}>{props.label}</p>
        </button>
    )
}
